module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_3_m.e96f1cc2e2d40aae65f1e2985b46067c.png";